<section class="record">
    <span ng-click="toggleDetails()">
        <span class="details-toggle" ng-class="{open:showDetails}"><i class="fa fa-angle-right"></i></span>
        <span c-activity-log-blurb activity="activity"></span>
        <span class="terminator">{{'setCurrentStageLog.sentFrom' | translate}}</span>
        <span id="fromStage" class="stage">{{localize(activity.StageName)}}</span>
        <span class="terminator">{{'setCurrentStageLog.sentTo' | translate}}</span>
        <span id="toStage" class="stage">{{localize(activity.ToStageName)}}</span>
        <span>({{localize(activity.Trigger)}})</span>
    </span>
</section>
<section class="details" c-toggle="showDetails">
    <section class="option-section">
        <h3 ng-show="activity.SelectedOption">
            {{'setCurrentStageLog.option' | translate}}
            : {{localize(activity.SelectedOption.FriendlyName)}}
        </h3>
    </section>
    <section class="recipients-section">
        <span ng-show="groupNames.length !== 0 || userNames.length !== 0">{{recipientsLabel}}:</span>
        <ul>
            <li class="group" ng-repeat="groupName in groupNames track by $index">{{localize(groupName)}}</li>
            <li class="user" ng-repeat="user in userNames track by $index">{{user.DisplayName}}&nbsp;({{user.UserName}})</li>
        </ul>
    </section>
    <section class="message-section" c-activity-log-message activity="activity"></section>
</section>
